import React, { useState } from "react";
import PropTypes from "prop-types";

import { Modal } from "@wwg/ui";
import ModalActionBar from "shared/ModalActionBar";
import Button from "shared/Button";
import Input from "shared/@forms/Input";
import TextArea from "shared/@forms/TextArea";
import { Select } from "shared/Select/Select";

import styles from "./CreateNewCalendarEventModal.module.css";
import classNames from "classnames";
import { DateRangePickerButton } from "shared/DateRangePickerButton/DateRangePickerButton";

/**
 * Modal that opens when add reminder is clicked in the actions dropdown on an incident details page.
 */
export function CreateNewCalendarEventModal({ onCreate, isOpen, onClose }) {
  const [eventData, setEventData] = useState({});
  const [reminderDays, setReminderDays] = useState("Select");
  const [errors, setErrors] = useState({});

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [hour, setHour] = useState("");
  const [min, setMin] = useState("");
  const [amp, setAmp] = useState("");

  const selectOptions = new Array(14);
  for (let i = 0; i < selectOptions.length; i++) {
    selectOptions[i] = (i + 1).toString();
  }

  const selectOptionsReminder = new Array(100);
  for (let i = 0; i < selectOptionsReminder.length; i++) {
    selectOptionsReminder[i] = (i + 1).toString();
  }

  const hourOptions = new Array(12);
  for (let i = 0; i < hourOptions.length; i++) {
    hourOptions[i] = (i + 1).toString();
  }

  const minOptions = new Array(59);
  for (let i = 0; i < minOptions.length; i++) {
    minOptions[i] = (i + 1).toString();
  }

  const handleForm = (e) => {
    setEventData({
      ...eventData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    let tempErrors = {
      title: "",
      reminderDays: "",
    };
    if (!eventData.title)
      tempErrors = { ...tempErrors, title: "Please enter a title" };
    if (reminderDays === "Select")
      tempErrors = {
        ...tempErrors,
        reminderDays: "Please select when to be reminded",
      };
    if (tempErrors.title || tempErrors.reminderDays)
      setErrors({ ...tempErrors });
    else {
      setErrors({});
      onCreate({
        title: eventData.title,
        caseNum: eventData.caseNum,
        location: eventData.location,
        notes: eventData.notes,
        reminderDays: reminderDays,
        time: hour + min + amp,
      });
    }
  };

  return (
    <Modal
      onClose={onClose}
      visible={isOpen}
      onClick={onClose}
      className={styles.modal}
      children={
        <>
          <div className={styles.createNewReportModalBody}>
            <div className={styles.title}>Create New</div>
            <div className={styles.hr} />

            <div className={styles.row}>
              <div className={styles.mr}>
                <div className={styles.label}>Add Title*</div>
                <Input
                  name="title"
                  placeholder="Title"
                  className={styles.input}
                  onChange={(e) => handleForm(e)}
                  onInput={() => setErrors({ ...errors, title: "" })}
                />
              </div>

              <div>
                <div className={styles.label}>Case Number</div>
                <Input
                  name="caseNum"
                  placeholder="Case Number"
                  className={styles.input}
                  onChange={(e) => handleForm(e)}
                  onInput={() => setErrors({ ...errors, caseNum: "" })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.mr}>
                <div className={styles.label}>Location</div>
                <Input
                  name="location"
                  placeholder="Location"
                  className={styles.input}
                  onChange={(e) => handleForm(e)}
                  onInput={() => setErrors({ ...errors, title: "" })}
                />
              </div>

              <div>
                <span className={styles.statusContainer}>
                  <span className={styles.rangePicker}>
                    <div className={styles.label}>Date</div>
                    <div>
                      <DateRangePickerButton
                        startDateString={startDate}
                        endDateString={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                      />
                    </div>
                  </span>
                  <span className={styles.select}>
                    <div className={styles.label}>Add Time</div>
                    <Select
                      options={hourOptions}
                      placeholder={hour ? hour : ""}
                      onChange={setHour}
                    />
                  </span>
                  <span className={classNames(styles.select, styles.marginTop)}>
                    <Select
                      options={minOptions}
                      placeholder={min ? min : ""}
                      onChange={setMin}
                    />{" "}
                  </span>
                  <span className={classNames(styles.select, styles.marginTop)}>
                    <Select
                      options={["AM", "PM"]}
                      placeholder={amp ? amp : ""}
                      onChange={setAmp}
                    />{" "}
                  </span>
                </span>
              </div>
            </div>
            <span className={styles.error}>{errors.title && errors.title}</span>
            <div className={styles.label}>Notes</div>
            <TextArea
              name="notes"
              className={styles.textArea}
              placeholder="Notes"
              onChange={(e) => handleForm(e)}
            />
            <div className={styles.link} onClick={() => alert("clicked upload")}>
            Upload Documents
          </div>
            <span className={styles.label}>Set Reminder</span>
            <span className={styles.reminderContainer}>
              <span className={styles.center}>Remind me in </span>
              <span className={classNames(styles.select, styles.select2)}>
                <Select
                  options={selectOptionsReminder}
                  placeholder={reminderDays}
                  onChange={setReminderDays}
                />
              </span>
              <span className={styles.center}> days.</span>
            </span>
            <span className={styles.error} style={{ marginTop: "0.25em" }}>
              {errors.reminderDays && errors.reminderDays}
            </span>
            <ModalActionBar>
              <div className={styles.buttonContainer}>
                <Button
                  className={styles.createButton}
                  onClick={() => handleSubmit()}
                >
                  CREATE
                </Button>
              </div>
            </ModalActionBar>
          </div>
        </>
      }
    />
  );
}

CreateNewCalendarEventModal.propTypes = {
  /** Function called when the Create btn is clicked.  */
  onCreate: PropTypes.func,
  /** Getter to determine if modal is displayed  */
  isOpen: PropTypes.bool,
  /** Callback function for when the modal is closed  */
  onClose: PropTypes.func,
};
